import { NavLink } from 'react-router-dom';

const links = [
  ['/', 'Dashboard'],
  ['/contracts', 'Signing Links'],
  ['/templates', 'PDF Templates'],
  ['/contacts', 'Contacts'],
  ['/settings', 'Settings'],
];

export default function Sidebar({ isOpen, onClose }) {
  return (
    <aside className={isOpen ? 'open' : ''}>
      <div className="brand">
        <span>CS</span>
        <strong>Contracts</strong>
        <button type="button" className="sidebar-close-btn" onClick={onClose} aria-label="Close Sidebar">
          ✕
        </button>
      </div>
      {links.map(([to, label]) => (
        <NavLink key={to} to={to} end={to === '/'} onClick={onClose}>
          {label}
        </NavLink>
      ))}
    </aside>
  );
}

